import React from 'react';
import { connect } from 'react-redux';

class Intro extends React.Component {

    render() {
       // console.log('Intro.Js render ', this.props.introduction);
     //   console.log('Intro.Js render bullet ', this.props.introduction.summary.summaryBullets);
        if (typeof this.props.introduction !== "undefined"  
            && typeof this.props.introduction.summaryBullets !== "undefined"
            && this.props.introduction.summaryBullets.length > 0) {

            //this.props.summaryBullets.sort((a, b) => { return a.id - b.id; });


            var summaryBullets = this.props.introduction.summaryBullets.map((summaryBullet,index) => {
                return <li key={index}>{summaryBullet}</li>
            })

         //   console.log("summaryBullets", summaryBullets);
        }
        return (
            <section className="o-section  t-section  ">

                <div className="o-section__header-bg  t-section__header"></div>
                <div className="o-section__content-bg  t-section__content"></div>
                <div className="o-container">
                    <div className="o-section__container">

                        <header className="o-section__header  t-section__header">
                            <div className="o-content">
                                <h2 className="o-section__heading">
                                    Intro
                                </h2>
                                <div className="o-content__body  o-section__description">
                                   
                                </div>
                            </div>
                        </header>

                        <div className="o-section__content  t-section__content  ">

                            <div className="o-content">
                                <div className="c-intro">
                                    <div className="o-content__body">
                                        <p>
                                          {this.props.introduction.summary} 
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <ul>
                                    {summaryBullets}
                                </ul> 
                            </div>
                        </div>
                        

                    </div>
                </div>
            </section>
        );
    }
}

const mapStateToProps = (state) => {
    //console.log('IntroJs 1: ', state)
    return {
        introduction: state.introduction.profile.introJson
    };
};

export default connect(mapStateToProps)(Intro);


// WEBPACK FOOTER //
// ./src/components/Intro.js